import script from "./DefaultHeaderLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultHeaderLayout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__